import React from "react";
import { PlayCircle } from "lucide-react";

/** Course thumbnail — renders the real image if set, else a gradient placeholder icon. */
export function CourseThumbnail({ url, size = "w-full aspect-video", className = "", testId }) {
  return (
    <div
      className={`${size} rounded-xl bg-gradient-to-br from-pink-500/20 to-orange-500/10 flex items-center justify-center border border-white/5 overflow-hidden ${className}`}
      data-testid={testId}
    >
      {url ? (
        <img src={url} alt="" className="w-full h-full object-cover" />
      ) : (
        <PlayCircle className="w-9 h-9 text-pink-300/70" />
      )}
    </div>
  );
}
